import { BsCheck } from 'react-icons/bs';
import { Flex } from '@ghq-abi/design-system';

import {
  ProgressBar,
  ProgressFill,
  Step,
  StepLabel,
  StepNumber,
  StepperContainer,
} from './styles';

interface StepperProps {
  steps: Array<{
    number: number;
    label: string;
    status?: 'completed' | 'active' | 'pending';
  }>;
}

export const StepperComponent: React.FC<StepperProps> = ({ steps }) => {
  const completedSteps = steps.filter(
    item => item.status === 'completed'
  ).length;
  const progressPercent = (completedSteps / (steps.length - 1)) * 100;

  const getStepPosition = (index: number, total: number) => {
    if (index === 0) return 'start';
    if (index === total - 1) return 'end';
    return 'center';
  };

  return (
    <Flex css={{ bg: '$white', px: '$24', mr: '-20px' }}>
      <StepperContainer>
        <ProgressBar>
          <ProgressFill style={{ width: `${progressPercent}%` }} />
        </ProgressBar>

        {steps.map((step, index) => (
          <Step
            key={step.number}
            position={getStepPosition(index, steps.length)}
          >
            <StepNumber status={step.status}>
              {step.status === 'completed' ? <BsCheck /> : step.number}
            </StepNumber>
            <StepLabel>{step.label}</StepLabel>
          </Step>
        ))}
      </StepperContainer>
    </Flex>
  );
};
